import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import moment from "moment";

import { DownloadOutlined } from "@toddle-edu/ds-icons";
import { IconButton, MediaCard } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";
import { downloadFromUrl, openLinkInNewTab } from "modules/Services";
import SeeMoreLessHtml from "UIComponents/SeeMoreLessHtml";
import { getStudentAlertTypeIcon } from "StudentAlertsSettings/modules/StudentAlertsSettingsUtils";

import classes from "./AlertCard.scss";

const styles = {
  seeMoreContainer: {
    display: "inline",
    whiteSpace: "pre-wrap",
    wordBreak: "normal",
    overflowWrap: "break-word",
  },
  seeMoreText: {
    marginLeft: "4px",
    display: "inline",
  },
};

const AlertCard = ({
  alert,
  downloadFromUrl,
  openLinkInNewTab,
  showHeader = true,
}) => {
  const {
    id,
    title,
    description,
    createdAt,
    attachments = [],
    alertType,
  } = alert;
  const { t } = useI18n();

  const { icon } = alertType;
  const AlertIcon = getStudentAlertTypeIcon({ iconMetaData: icon });

  const componentTestId = `studentAlert-${id}`;

  const createdAtDate = moment(createdAt).format("DD MMM YYYY, hh.mm A");
  const createdAtClasses = classNames(classes.textSubtle, "text-body-s");

  return (
    <div className={classes.alertCardContainer}>
      {showHeader ? (
        <div className={classes.alertHeader}>
          <div className={classes.iconContainer}>
            <AlertIcon size="xx-small" />
          </div>
          <div className={"text-label"}>{title}</div>
        </div>
      ) : null}
      {!_.isEmpty(description) ? (
        <div className={"text-body"}>
          <SeeMoreLessHtml
            truncateLength={100}
            fullSource={description}
            containerStyle={styles.seeMoreContainer}
            seeMoreLessTextStyle={styles.seeMoreText}
          />
        </div>
      ) : null}
      {!_.isEmpty(attachments) ? (
        <div className={classes.attachmentList}>
          {_.map(attachments, attachment => {
            const { id, url, name, type, mimeType, metadata } = attachment;
            const handleDownload = () => {
              downloadFromUrl({
                attachment,
                shouldAskForSave: true,
              });
            };

            const handleClick = () => {
              openLinkInNewTab({ url });
            };

            const attachmentOptions = !_.isEqual(type, "LINK") ? (
              <IconButton
                dsVersion="2.0"
                size="x-small"
                type="plain"
                variant="neutral"
                shouldStopPropagation
                onClick={handleDownload}
                icon={<DownloadOutlined />}
                testId={`${componentTestId}-attachment-${id}-download`}
              />
            ) : null;

            return (
              <MediaCard
                key={id}
                dsVersion="2.0"
                size={metadata?.size}
                src={url}
                thumbUrl={url}
                alt={name}
                name={name}
                type={type}
                mimeType={mimeType}
                cardType="small"
                testId={`${componentTestId}-attachment-${id}`}
                options={attachmentOptions}
                onClick={handleClick}
              />
            );
          })}
        </div>
      ) : null}
      <div className={createdAtClasses}>
        {t("common:added_label", {
          label: createdAtDate,
        })}
      </div>
    </div>
  );
};

const mapActionCreators = {
  downloadFromUrl,
  openLinkInNewTab,
};

export default connect(null, mapActionCreators)(AlertCard);
